(function () {
  if (window.__copyBtnInit) {
    return;
  }

  window.__copyBtnInit = true;
  const RESET_DELAY = 1500;

  function resetState(btn) {
    btn.classList.remove("copied", "notCopied");

    const status = btn.querySelector(".copy-btn__status");
    if (status) {
      status.textContent = "";
    }
  }

  function setState(btn, success) {
    btn.classList.remove("copied", "notCopied");
    btn.classList.add(success ? "copied" : "notCopied");

    const status = btn.querySelector(".copy-btn__status");
    if (status) {
      status.textContent = success ? btn.dataset.copySuccess || "" : btn.dataset.copyError || "";
    }

    if (btn.copyResetTimer) {
      clearTimeout(btn.copyResetTimer);
    }
    btn.copyResetTimer = setTimeout(function () {
      resetState(btn);
    }, RESET_DELAY);
  }

  function legacyCopy(text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.top = "-9999px";
    textArea.style.left = "-9999px";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    let successful = false;
    try {
      successful = document.execCommand("copy");
    } catch (error) {
      successful = false;
    }

    document.body.removeChild(textArea);
    return successful;
  }

  function copyURL(btn) {
    const url = btn.dataset.copyHref || window.location.href;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).then(
        function () {
          setState(btn, true);
        },
        function () {
          // Rejected (permission/insecure context) — try the legacy path.
          setState(btn, legacyCopy(url));
        }
      );
      return;
    }

    setState(btn, legacyCopy(url));
  }

  document.addEventListener("click", function (event) {
    const btn = event.target.closest(".copy-btn");
    if (!btn) {
      return;
    }

    event.preventDefault();
    copyURL(btn);
  });
})();
